import React, { useEffect, useMemo, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import Table from "../../../components/Table/Table"
import LinearProgress from "@mui/material/LinearProgress"
import axios from "axios"
import { Link } from "react-router-dom"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import { logOut } from "../../../utils/logOut"
import { Fade, TextField, Typography } from "@mui/material"
import TranslatedText from "../../../utils/Translate"
import SimplifiedTable from "../../../components/Table/SimpleTable"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function ContactGroups() {
    const dispatch = useAppDispatch()
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        dispatch(setCurrentPage(`Contact groups`))
    }, [dispatch]);

    const [startRow, setStartRow] = useState(0)
    const [pageRows, setPageRows] = useState(100)
    const [maxRows, setMaxRows] = useState(pageRows)
    const [totalRows, setTotalRows] = useState(0)

    const [filterParams, setFilterParams] = useState<any>({
            leadgroupcode: ''
        })
    

    const { showSnackbar } = useSnackbar();

    //Get contact groups
    async function fetchData(params: object = {}) {
        setLoading(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/contactgroup`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: { ...params, startRow, maxRows, calculatetotalcount: true }
            })
            if (response.data !== null) {
                setTotalRows(+response.data[0].totalcount)
                setTableData(response.data.slice(1))
            }

            console.log(response.data);

            setLoading(false)
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }
    //Pagination

    useEffect(() => {
        fetchData()
    }, [startRow, maxRows])

    //Pagination buttons
    function handleBack() {
        if ((startRow - pageRows) < 0) {
            setStartRow(0)
            setMaxRows(pageRows)

        }
        else {
            setStartRow((prev) => prev - pageRows)
            setMaxRows((prev) => prev - pageRows)
        }
    }

    function handleNext() {

        setStartRow((prev) => prev + pageRows)
        setMaxRows((prev) => prev + pageRows)

    }

    function handleEnd() {

        setStartRow(totalRows % pageRows === 0 ? totalRows - pageRows : totalRows - (totalRows % pageRows))
        setMaxRows(totalRows % pageRows === 0 ? totalRows : totalRows - (totalRows % pageRows) + pageRows)

    }

    function handleStart() {

        setStartRow(0)
        setMaxRows(pageRows)

    }

    const totalPages = Math.ceil(totalRows / pageRows);
    const currentPage = Math.ceil(maxRows / pageRows);

    //on load - fetch data
    // useEffect(() => {
    //     fetchData()
    // }, [])

    const memoizedTable = useMemo(() => <SimplifiedTable rows={tableData} page={'contactgroup'} />, [tableData]);


    return (
        <>
            <Box sx={{ mb: 1, alignItems: "center", display: 'flex', width: "100vw", justifyContent: "space-between" }}>
                <Box >
                    <Link to='/contactgroup' state={{ type: 'add' }}>
                        <Button size="small" sx={{ mr: 1 }} variant="outlined"><TranslatedText text={"Add contact group"} /></Button>
                    </Link>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mr: 45 }}>
                    <TextField sx={{ minWidth: 220 }} value={filterParams.leadgroupcode} onChange={(e) => setFilterParams({ ...filterParams, leadgroupcode: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Contact group code'} />} />
                    <Button onClick={() => fetchData(filterParams)} size="small" sx={{ mr: 1 }} variant="contained" ><TranslatedText text={'Apply'} /></Button>
                </Box>
                <Box></Box>
            </Box>
            {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                <Box sx={{ height: '82vh', display: 'flex', flexDirection: 'column' }}>
                    {memoizedTable}
                    <Fade in={!loading} timeout={300}>
                        <Box sx={{ display: 'flex', alignItems: "center", marginTop: 'auto' }}>
                            <Box sx={{ mt: 2 }}>
                                <Button disabled={startRow === 0} onClick={() => handleStart()} size="small" sx={{ mr: 1 }} variant="outlined" >{"<<"}</Button>
                                <Button disabled={startRow === 0} onClick={() => handleBack()} size="small" sx={{ mr: 1 }} variant="outlined" ><span>{'<'}&nbsp;</span> {<TranslatedText text={"Back"} />}</Button>
                                <Button disabled={maxRows >= totalRows} onClick={() => handleNext()} size="small" sx={{ mr: 1 }} variant="outlined" >{<TranslatedText text={'Next'} />}&nbsp;<span>{'>'}</span></Button>
                                <Button disabled={maxRows >= totalRows || tableData.length < pageRows} onClick={() => handleEnd()} size="small" sx={{ mr: 1 }} variant="outlined" >{">>"}</Button>
                            </Box>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Rows on page:'} /> {pageRows}</Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}>
                                <TranslatedText text={'Page:'} /> {currentPage} / {totalPages}
                            </Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Total rows:'} /> {totalRows}</Typography>
                        </Box>
                    </Fade>
                </Box>
            }
        </>
    )
}